module.exports = __webpack_public_path__ + "static/img/72 (1).d6268ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/72 (1).jpg
// module id = r0uX
// module chunks = 0